module.exports = __webpack_public_path__ + "img/early.6c00f4c6.png";